import { render, staticRenderFns } from "./HeaderActionButton.vue?vue&type=template&id=2657d64d&scoped=true"
import script from "./HeaderActionButton.vue?vue&type=script&lang=js"
export * from "./HeaderActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2657d64d",
  null
  
)

export default component.exports